import { defaultFormList } from '../constants/constants';
import { formsIndicators } from './checkFormsCompleted';
import { Task } from '../../taskList/interfaces';
import { isSimplifiedFlow } from '../../workflowConfigurablePages/utils/simplifiedFormStatus';

export const getTaskItemList = (tasks: Task[]): Task[] => {
  let filteredFormDataObj;
  if (!isSimplifiedFlow()) {
    const indicatorObj = formsIndicators();
    filteredFormDataObj = defaultFormList.filter((item) => item.indicator && indicatorObj[item.indicator]);
  }
  const taskList = [
    ...tasks.map((task: Task) => {
      return {
        ...task,
        duration: task.items.reduce((accumulator, currentValue) => {
          if (currentValue && currentValue.duration) {
            return accumulator + currentValue.duration;
          }
          return accumulator;
        }, 0),
      };
    }),
  ];
  if (filteredFormDataObj && filteredFormDataObj.length > 0) {
    taskList.unshift({
      id: 1,
      title: 'forms',
      duration: filteredFormDataObj.reduce((accumulator, currentValue) => accumulator + currentValue.duration, 0),
      items: filteredFormDataObj,
    });
  }

  return taskList;
};
